import React from 'react';
import { FiEdit3, FiFileText, FiBarChart } from 'react-icons/fi';
import Hero from '../../components/sections/Hero';
import AuditForm from '../../components/sections/AuditForm';
import SEO from '../../components/common/SEO';
import SafeIcon from '../../components/common/SafeIcon';
import { servicesData } from '../../data/services';

const ContentMarketing = () => {
  const data = servicesData['content-marketing'];

  return (
    <>
      <SEO title={`${data.title} | Alberta SEO Pro`} description={data.description} />
      <Hero title={data.title} subtitle={data.longDesc} />
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16">
            <div>
              <h2 className="text-3xl font-bold text-slate-900 mb-6">Strategic Content That Converts</h2>
              <p className="text-lg text-slate-600 mb-8">
                Content is more than words on a page. It's about demonstrating your expertise to both Google and your future clients.
              </p>
              <ul className="space-y-6">
                {data.features.map((feature, i) => (
                  <li key={i} className="flex gap-4">
                    <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center text-blue-600 shrink-0">
                      <SafeIcon icon={FiFileText} />
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900">{feature}</h4>
                      <p className="text-slate-500 text-sm">Tailored specifically for the Alberta home services market.</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative">
              <AuditForm 
                type="Content"
                title="Free Content Strategy Session"
                subtitle="We'll analyze your top 3 competitors and give you a 6-month content roadmap to dominate your local market."
                buttonText="Get My Content Strategy"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContentMarketing;